import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';
import type {IconProps} from '../svg-icon-wrapper';

import BookRegular from './book-regular-icon.svg';

interface Props extends IconProps {
    color?: string;
}

function SvgComponent(props: Props) {
    const validProps = Object.assign({}, props);
    // @ts-expect-error
    delete validProps.styles;

    return <BookRegular {...validProps} />;
}

SvgComponent.iconName = 'bookRegular';

export const BookRegularIcon = svgIconWrapper(SvgComponent);
